import { render, staticRenderFns } from "./photoCapture.vue?vue&type=template&id=fa58313a&scoped=true"
import script from "./photoCapture.vue?vue&type=script&lang=js"
export * from "./photoCapture.vue?vue&type=script&lang=js"
import style0 from "./photoCapture.vue?vue&type=style&index=0&id=fa58313a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58313a",
  null
  
)

export default component.exports